 export enum FeatureFlagModuleEnum {
NonDefini = 0,
BulletinClarifie = 1,
TransfertSql = 2,
EnqueteSatisfactionPst = 3,
ModuleCongeV3 = 4,
ModuleCongeV4 = 5,
AncienneEnqueteSatisfactionPst = 6,
Jimo = 7,
AttestationCrpcenTpt = 8,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/FeatureFlagModuleEnum.ts